import { reactive } from 'vue'
import { Capacitor } from '@capacitor/core'
import api from './api.js'

export const reminders = reactive({ available:false, loading:false, state:null, item:null, error:'', returned:false })
let userId=null, generation=0, token=null, timer=null, router=null, push=null, listening=false
let registrationGeneration=-1, nativeActive=true, pendingTap=null
let foodTimer=null
let deviceQueue=Promise.resolve()
function deviceOperation(fn){const task=deviceQueue.catch(()=>{}).then(fn);deviceQueue=task;return task}
function unregisterDevice(){if(!native())return Promise.resolve();return deviceOperation(async()=>{await initPush();await push.unregister()}).catch(()=>{})}
function registerDevice(g){return deviceOperation(async()=>{if(g!==generation)return;registrationGeneration=g;await push.register()})}
const KEY='zoya-reminder-installation'
export function installationId(){ let id=localStorage.getItem(KEY); if(!id){id=crypto.randomUUID();localStorage.setItem(KEY,id)} return id }
const native=()=>Capacitor.isNativePlatform()
const visible=()=>nativeActive&&document.visibilityState==='visible'
const environment=()=>String(api.defaults.baseURL).includes('staging.zozhnik.ru')?'staging':'production'
export async function refresh(){
  const g=generation
  if(!userId)return
  try{const {data}=await api.get('/notifications/state');if(g!==generation)return;reminders.available=!!data.available;reminders.state=data}
  catch{if(g===generation)reminders.available=false}
}
async function bind(permission='prompt',deviceToken=null,g=generation){
  if(!userId||!reminders.available||g!==generation)return
  await api.post('/notifications/installation',{id:installationId(),platform:native()?Capacitor.getPlatform():'web',permission,token:deviceToken,version:typeof __APP_VERSION__==='string'?__APP_VERSION__:'dev'})
}
function handleTap(data,action='open'){
  if(!data?.reminder_id||data.environment!==environment())return
  pendingTap={data,action}
  if(userId&&reminders.available){const tap=pendingTap;pendingTap=null;void perform(tap.data.reminder_id,tap.action)}
}
async function initPush(){
  if(!native())return
  push ||= (await import('@capacitor/push-notifications')).PushNotifications
  if(listening)return
  listening=true
  await push.addListener('registration',v=>{if(userId&&registrationGeneration===generation&&reminders.state?.consented)void bind('granted',v.value).catch(()=>{})})
  await push.addListener('registrationError',()=>{if(userId&&registrationGeneration===generation)reminders.error='Не удалось подключить уведомления на устройстве'})
  await push.addListener('pushNotificationActionPerformed',v=>{
    if(v.actionId==='dismiss')return
    handleTap(v.notification?.data,['less','disable','skip'].includes(v.actionId)?v.actionId:'open')
  })
  await push.addListener('pushNotificationReceived',v=>{
    const d=v.data||{}
    if(visible()&&d.environment===environment()&&userId&&reminders.state?.settings?.enabled)
      reminders.item={id:d.reminder_id,kind:d.kind,text:v.body||d.body||'Зоя: новое сообщение',expires_at:d.expires_at}
  })
  const {App}=await import('@capacitor/app')
  await App.addListener('appStateChange',({isActive})=>{nativeActive=isActive;void presence(isActive)})
  if(Capacitor.getPlatform()==='android')await push.createChannel({id:'zoya_reminders',name:'Напоминания Зои',description:'Голод, сытость и удобные записи',importance:3,visibility:0})
}
export async function allowDevice(){
  const allowed=()=>reminders.state?.consented&&reminders.state?.settings?.enabled&&reminders.state?.has_food
  if(!allowed()){reminders.error='Сначала включите напоминания от Зои';return 'prompt'}
  const g=generation
  if(!native()){await bind('granted');return 'granted'}
  await initPush()
  if(g!==generation||!allowed())return 'prompt'
  let p=await push.checkPermissions()
  if(g!==generation||!allowed())return p.receive
  if(p.receive==='prompt'||p.receive==='prompt-with-rationale')p=await push.requestPermissions()
  if(g!==generation||!allowed())return p.receive
  if(p.receive==='granted')await registerDevice(g)
  else await bind(p.receive==='denied'?'denied':'prompt',null,g)
  await refresh();return p.receive
}
export async function save(settings,{consent=false,emailConsent=false}={}){
  const g=generation;reminders.loading=true;reminders.error=''
  try{
    const {data}=await api.put('/notifications/settings',{settings,version:reminders.state.version,consent,emailConsent})
    if(g!==generation)return
    reminders.state={...reminders.state,...data,consented:reminders.state.consented||consent};await refresh();return data
  }catch(e){if(g===generation)reminders.error=e.response?.data?.error||'Не удалось сохранить настройки';throw e}
  finally{if(g===generation)reminders.loading=false}
}
export async function decline(){await api.post('/notifications/prompt',{declined:true});await refresh()}
export async function perform(id,action='open'){
  reminders.error='';const g=generation
  try{
    const {data}=await api.post(`/notifications/${id}/action`,{action,operationId:crypto.randomUUID()})
    if(g!==generation)return
    if(String(reminders.item?.id)===String(id))reminders.item=null
    if(data.path&&router)await router.push(data.path)
    if(data.message)reminders.error=data.message
    if(['less','disable'].includes(action))await refresh()
    return data
  }catch(e){if(g===generation)reminders.error=e.response?.data?.error||'Подсказка пока недоступна'}
}
async function feed(){
  const g=generation
  if(!userId||!reminders.available||!visible())return
  try{const {data}=await api.get('/notifications/feed');if(g===generation){reminders.item=data.items?.[0]||null;if(reminders.item?.kind==='return')reminders.returned=false}}catch{}
}
async function presence(opened=false){
  const g=generation
  if(!userId||!reminders.available)return
  try{const {data}=await api.post('/notifications/presence',{foreground:visible(),opened:opened&&visible(),installationId:installationId()});if(g===generation&&data.returned)reminders.returned=true}catch{}
  if(g===generation&&visible())await feed()
}
function visibility(){void presence(visible())}
function food(){clearTimeout(foodTimer);foodTimer=setTimeout(async()=>{await refresh();void presence(false)},300)}
export async function attach(user,r){
  const changed=userId&&userId!==user?.id
  if(changed){revokeDevice(token);void unregisterDevice()}
  generation++;const g=generation;clearInterval(timer);clearTimeout(foodTimer);userId=user?.id||null;router=r;token=localStorage.getItem('zoya-token')
  Object.assign(reminders,{available:false,loading:false,state:null,item:null,error:'',returned:false})
  document.removeEventListener('visibilitychange',visibility);window.removeEventListener('zoya:entry-saved',food);window.removeEventListener('zoya:communication-saved',food)
  if(!userId){void unregisterDevice();return}
  if(native())await initPush()
  await refresh();if(g!==generation||!reminders.available)return
  document.addEventListener('visibilitychange',visibility);window.addEventListener('zoya:entry-saved',food);window.addEventListener('zoya:communication-saved',food)
  await presence(true);if(g!==generation)return
  if(!native())await bind('granted',null,g)
  else if(reminders.state?.consented){
    const permission=(await push.checkPermissions()).receive
    if(g!==generation)return
    if(permission==='granted')await registerDevice(g)
    else await bind(permission==='denied'?'denied':'prompt',null,g)
  }else await bind('prompt',null,g)
  if(g!==generation)return
  if(pendingTap){const tap=pendingTap;pendingTap=null;void perform(tap.data.reminder_id,tap.action)}
  timer=setInterval(()=>{if(visible())void presence(false)},45000)
}
export function detach(expectedUser){
  if(expectedUser==null||expectedUser!==userId)return
  const oldToken=token,oldUser=userId;generation++;userId=null;registrationGeneration=-1;clearInterval(timer);clearTimeout(foodTimer);pendingTap=null
  void unregisterDevice()
  Object.assign(reminders,{available:false,loading:false,state:null,item:null,error:'',returned:false})
  document.removeEventListener('visibilitychange',visibility);window.removeEventListener('zoya:entry-saved',food);window.removeEventListener('zoya:communication-saved',food)
  if(oldToken&&oldUser)revokeDevice(oldToken)
}
function revokeDevice(oldToken){if(oldToken){const base=api.defaults.baseURL||'/api';void fetch(`${base}/notifications/installation/${installationId()}`,{method:'DELETE',headers:{Authorization:'Bearer '+oldToken},keepalive:true}).catch(()=>{})}}
